/*
 * fn: exportCsv
 *
 * Exports a downloadable CSV from a matrix of strings
 *
 */
type Props = {
  filename: string
  rows: string[][]
}

export const exportCsv = ({ filename, rows }: Props) => {
  if (rows.length === 0) return

  const csv = rows.map((row) => row.map((col) => `"${String(col || '').replace(/"/g, '""')}"`).join(','))

  const blob = new Blob([csv.join('\n')], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  link.click()

  URL.revokeObjectURL(url)
}
